export default __webpack_public_path__ + "static/media/DIR RAM JURID. PUBL. PDF.a5e422ac.pdf";